import { render, staticRenderFns } from "./ShopInfo.vue?vue&type=template&id=1221313e&scoped=true&"
import script from "./ShopInfo.vue?vue&type=script&lang=js&"
export * from "./ShopInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShopInfo.vue?vue&type=style&index=0&id=1221313e&lang=scss&scoped=true&"
import style1 from "./ShopInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1221313e",
  null
  
)

export default component.exports